import { gql } from "@apollo/client";

export const GET_ALL_JOBS_WITH_FULL_DETAIL = gql`
    query {
        allJobs {
            id

            name

            customerName
            customerContactName
            customerPhone
            customerEmail

            street1
            street2
            city
            state
            zipcode

            estimatedStartDate

            isActive

            createdBy {
                id
                firstName
                lastName
            }
            lastUpdatedBy {
                id
                firstName
                lastName
            }
        }
    }
`

// Job by ID
export const GET_JOB_BY_ID_WITH_FULL_DETAIL = gql`
    query job($id: Int!) {
        job(id: $id) {
            id

            name

            customerName
            customerContactName
            customerPhone
            customerEmail

            street1
            street2
            city
            state
            zipcode

            isActive

            createdBy {
                id
                firstName
                lastName
            }
            lastUpdatedBy {
                id
                firstName
                lastName
            }

        }
    }
`

export const GET_ALL_JOBS_FOR_SELECT_FIELD = gql`
    query {
        allJobs {
            id
            name
        }
    }
`

export const GET_JOB_BY_ID_FOR_EDIT_FORM = gql`
    query job($id: Int!) {
        job(id: $id) {
            id

            name
            estimatedStartDate
            wageRate

            customerName
            customerContactName
            customerPhone
            customerEmail

            street1
            street2
            city
            state
            zipcode

            isActive
        }
    }
`

// Job - Name
export const GET_JOB_BY_ID_NAME = gql`
    query job($id: Int!) {
        job(id: $id) {
            name
        }
    }
`

// Job - Info
export const GET_JOB_BY_ID_WITH_INFO = gql`
    query job($id: Int!) {
        job(id: $id) {

            name

            street1
            street2
            city
            state
            zipcode

            estimatedStartDate
            isActive
        }
    }
`

// Job - Customer
export const GET_JOB_BY_ID_WITH_CUSTOMER = gql`
    query job($id: Int!) {
        job(id: $id) {

            customerName
            customerContactName
            customerPhone
            customerEmail

        }
    }
`

// Job - Total Man Hours

// All Jobs with no Start Date
export const GET_ALL_JOBS_WITH_NO_START_DATE = gql`
    query {
        jobsWithNoStartDate {
            id
            name
            street1
            street2
            city
            state
            zipcode
            estimatedStartDate
        }
    }
`

// All Job Das for this week
export const GET_ALL_JOBS_IN_DATE_RANGE = gql`
    query jobsInDateRange($startDate: Date!, $endDate: Date!) {
        jobsInDateRange(startDate: $startDate, endDate: $endDate) {
            id
            name
            street1
            street2
            city
            state
            zipcode
            estimatedStartDate
            customerName
        }
    }
`

// Job - Job Days
export const GET_ALL_JOB_DAYS_FOR_JOB = gql`
    query job($id: Int!) {
        job(id: $id) {
            jobDays {
                id
                date
                crewMemberAssignments {
                    preliminaryApproval
                    finalApproval
                    isPaid
                    paidDate
                    startTime
                    endTime
                    crewMember {
                        firstName
                        lastName
                        isForeman
                    }
                    signOff {
                        id
                    }
                }
            }
        }
    }
`

// Job - Equipment Requests
export const GET_ALL_EQUIPMENT_REQUESTS_FOR_JOB = gql`
    query job($id: Int!) {
        job(id: $id) {
            jobEquipmentRequests {
                id
                datetimeCreated
                datetimeFulfilled
                requestedBy {
                    firstName
                    lastName
                }
                equipmentRequestItemsForEquipmentRequest {
                    id
                }
                status
            }
        }
    }
`

export const GET_INVENTORY_LOGS_FOR_JOB = gql`
    query inventoryLogsForJobs($id: Int!) {
        shippingLogsForJob(job: $id) {
            id
            dateAndTime
            quantity
            equipment {
                id
                name
            }
        }

        receivingLogsForJob(job: $id) {
            id
            dateAndTime
            quantity
            equipment {
                id
                name
            }
        }
    }
`